import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { Locale } from '~/App/shared/localization/types';
import 'dayjs/locale/sv';
import 'dayjs/locale/pl';
import 'dayjs/locale/et';
import 'dayjs/locale/fi';
import 'dayjs/locale/de';

const customConfigs: Partial<Record<Locale, Record<string, unknown>>> = {
  sv: {
    calendar: {
      sameDay: '[Idag] HH:mm',
      nextDay: '[Imorgon] HH:mm',
      lastDay: '[Igår] HH:mm',
      nextWeek: '[På] dddd HH:mm',
      lastWeek: '[I] dddd[s] HH:mm',
      sameElse: 'YYYY-MM-DD'
    }
  }
};

dayjs.extend(updateLocale);
dayjs.extend(advancedFormat);

export const loadDayJSLocale = (language: Locale) => {
  // `en` and `en-SE` both use dayjs' built-in English locale (no module to
  // load); dayjs has no `en-SE` locale, so don't try to switch to it.
  if (language === 'en' || language === 'en-SE') {
    return;
  }

  const customConfig = customConfigs?.[language];
  if (customConfig) {
    dayjs.updateLocale(language, customConfig);
  }

  dayjs.locale(language);
};

export default dayjs;
